'use strict';
define(['app'], function (app) {
    function Controller($scope, $q, $document, $element) {
        var ctrl = this;

        ctrl.visible = false;
        ctrl.loading = false;
        ctrl.busy = false;
        ctrl.lists = [];
        ctrl.search = '';
        ctrl.newName = '';
        ctrl.error = null;

        ctrl.toggle = toggle;
        ctrl.add = add;
        ctrl.create = create;
        ctrl.filteredLists = filteredLists;

        function rowsFrom(response) {
            var body = response && response.data !== undefined ? response.data : response;
            if (body && Array.isArray(body.rows)) {
                return body.rows;
            }
            if (body && body.data && Array.isArray(body.data.rows)) {
                return body.data.rows;
            }
            return null;
        }

        function errorMessage(error) {
            return error && (
                (error.data && error.data.error && error.data.error.message)
                || (error.error && error.error.message)
                || error.message
            ) || 'Impossibile completare l’operazione.';
        }

        function toggle(event) {
            if (event) {
                event.stopPropagation();
            }
            if (ctrl.options && ctrl.options.buttonDisabled) {
                return;
            }
            ctrl.visible = !ctrl.visible;
            if (ctrl.visible) {
                ctrl.search = '';
                ctrl.error = null;
                loadLists();
            }
        }

        function loadLists() {
            if (!ctrl.options || !ctrl.options.getAllKeywordList) {
                return;
            }
            ctrl.loading = true;
            ctrl.error = null;
            $q.when(ctrl.options.getAllKeywordList())
                .then(function (response) {
                    ctrl.lists = rowsFrom(response) || [];
                })
                .catch(function (error) {
                    ctrl.error = errorMessage(error);
                })
                .finally(function () {
                    ctrl.loading = false;
                });
        }

        function add(list, event) {
            if (event) {
                event.stopPropagation();
            }
            if (!list || ctrl.busy || !ctrl.options || !ctrl.options.addQueriesToKeywordlist) {
                return;
            }
            ctrl.busy = true;
            ctrl.error = null;
            $q.when(ctrl.options.addQueriesToKeywordlist(
                ctrl.options.queriesSelected || [],
                list.keywordListId,
            ))
                .then(function (response) {
                    ctrl.lists = rowsFrom(response) || ctrl.lists;
                    ctrl.visible = false;
                })
                .catch(function (error) {
                    ctrl.error = errorMessage(error);
                })
                .finally(function () {
                    ctrl.busy = false;
                });
        }

        function create(event) {
            if (event) {
                event.stopPropagation();
            }
            var name = String(ctrl.newName || '').trim();
            if (!name || ctrl.busy || !ctrl.options || !ctrl.options.createAKeywordList) {
                return;
            }
            ctrl.busy = true;
            ctrl.error = null;
            $q.when(ctrl.options.createAKeywordList(name))
                .then(function (response) {
                    var lists = rowsFrom(response) || ctrl.lists;
                    var created = lists.filter(function (item) {
                        return item.keywordListName === name;
                    })[0];
                    if (!created) {
                        throw new Error('Lista creata ma non trovata.');
                    }
                    return ctrl.options.addQueriesToKeywordlist(
                        ctrl.options.queriesSelected || [],
                        created.keywordListId,
                    );
                })
                .then(function () {
                    ctrl.newName = '';
                    ctrl.visible = false;
                })
                .catch(function (error) {
                    ctrl.error = errorMessage(error);
                })
                .finally(function () {
                    ctrl.busy = false;
                });
        }

        function filteredLists() {
            var term = String(ctrl.search || '').trim().toLowerCase();
            if (!term) {
                return ctrl.lists;
            }
            return ctrl.lists.filter(function (list) {
                return String(list.keywordListName || '').toLowerCase().indexOf(term) !== -1;
            });
        }

        function closeOnOutsideClick(event) {
            if (ctrl.visible && $element[0] && !$element[0].contains(event.target)) {
                $scope.$applyAsync(function () {
                    ctrl.visible = false;
                });
            }
        }

        $document.on('click', closeOnOutsideClick);
        $scope.$on('$destroy', function () {
            $document.off('click', closeOnOutsideClick);
        });
    }

    app.component('stKeywordListV2', {
        bindings: {
            options: '<',
        },
        controller: Controller,
        templateUrl: 'app/components/st-keyword-list-v2/st-keyword-list-v2.html',
    });
});
